<template>
  <div class="ai-visibility-citation-toolbar">
    <div class="ai-visibility-citation-toolbar__copy">
      <h2>{{ title }}</h2>
      <p v-if="subtitle">{{ subtitle }}</p>
    </div>
    <div class="ai-visibility-citation-toolbar__controls">
      <label class="ai-visibility-citation-toolbar__toggle">
        <span>Group by website</span>
        <ai-visibility-toggle
          :value="groupByWebsite"
          aria-label="Group by website"
          @input="$emit('update:group-by-website', $event)"
        />
      </label>
      <ai-visibility-search-input
        :value="search"
        placeholder="Search"
        @input="$emit('update:search', $event)"
        @clear="$emit('update:search', '')"
      />
      <icon-button
        icon="file_download"
        aria-label="Export citation sources"
        @click="$emit('export')"
      />
    </div>
  </div>
</template>

<script>
import AiVisibilitySearchInput from '../../../ui/controls/AiVisibilitySearchInput.vue'
import AiVisibilityToggle from '../../../ui/controls/AiVisibilityToggle.vue'
import IconButton from '../../../ui/controls/IconButton.vue'

export default {
  name: 'CitationSourcesToolbar',
  components: {
    AiVisibilitySearchInput,
    AiVisibilityToggle,
    IconButton,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
    search: {
      type: String,
      required: true,
    },
    groupByWebsite: {
      type: Boolean,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-citation-toolbar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding: 20px;
}

.ai-visibility-citation-toolbar__copy {
  min-width: 220px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ai-visibility-citation-toolbar h2 {
  color: var(--v-mainColor-base);
  font-size: 20px;
  font-weight: 500;
  line-height: 1.3;
  margin: 0;
}

.ai-visibility-citation-toolbar p {
  color: var(--v-darkGrayColor-base);
  font-size: 16px;
  font-weight: 500;
  line-height: 1.45;
  margin: 5px 0 0;
}

.ai-visibility-citation-toolbar__controls {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;

  ::v-deep .ai-visibility-icon-button i {
    color: #363636;
  }
}

.ai-visibility-citation-toolbar__toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--v-mainColor3-base);
  font-size: 13px;
  font-weight: 800;
  white-space: nowrap;

  span {
    font-size: 16px;
    font-weight: 600;
    color: var(--v-mainColor-base);
  }

}

@media (max-width: 860px) {
  .ai-visibility-citation-toolbar {
    flex-direction: column;
  }

  .ai-visibility-citation-toolbar__controls {
    justify-content: flex-start;
    width: 100%;
  }
}
</style>
